"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Represents data for report structure (e.g. reportDto)
 */
var ReportChangeEvent = /** @class */ (function () {
    function ReportChangeEvent(reportTableView, datasetId) {
        this.reportTableView = reportTableView;
        this.datasetId = datasetId;
    }
    return ReportChangeEvent;
}());
exports.ReportChangeEvent = ReportChangeEvent;
//# sourceMappingURL=report-change-event.js.map